/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Format {
  UNKNOWN = 'UNKNOWN',
  TEXT = 'text',
  UNIVERSAL_IMAGE = 'universal_image',
  ORIGINAL = 'original',
  SUMMARY = 'summary',
  PDF = 'pdf',
  DOCX = 'docx',
  HTML = 'html',
  PODCAST = 'podcast',
}
